module.exports = __webpack_public_path__ + "img/map.5b478b14.jpg";